import "./style.css";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { MeshBasicMaterial, Object3D, Raycaster, Mesh, SphereBufferGeometry } from "three"
import { TransformControls} from "three/examples/jsm/controls/TransformControls"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader"
import { RGBELoader} from "three/examples/jsm/loaders/RGBELoader"
import lottie from "lottie-web"
import { initializeApp } from "firebase/app"; 
import { getAnalytics } from "firebase/analytics"; 
import { 
  EffectComposer, 
  EffectPass, 
  RenderPass, 
  GodRaysEffect, 
} from "postprocessing";
import gsap from "gsap";
//Allah forgive me for what I'm about to code//


const firebaseConfig = { 
  apiKey: "AIzaSyByrKpAIVFpf2XHXI1EWX07W0MYxIXZe-M", 
  authDomain: "keysmartexperience.firebaseapp.com", 
  projectId: "keysmartexperience", 
  storageBucket: "keysmartexperience.appspot.com", 
  messagingSenderId: "1083208863964", 
  appId: "1:1083208863964:web:8aad5d2a659673e8bf2419", 
  measurementId: "G-N4W6QCCDSM" 
}; 
 
// Initialize Firebase 
const app = initializeApp(firebaseConfig); 
const analytics = getAnalytics(app);


//Global variables//
let mainScene, camera, renderer, oControls, light, light2, model1, material, directionalLight, tControls, envLoader
let mesh = []
let raycaster
let txtDiv
let shell
let inputXpos
let inputYpos
let inputZpos
const button1 = document.getElementById('but1')
const button2 = document.getElementById('but2')
const button3 = document.getElementById('but3')
const button4 = document.getElementById('load-button')
const cursor = document.getElementById('cursorDiv')
const controlIcon = document.getElementById('controls-icon')
const button5 = document.getElementById('controls-icon')
const assembleIcon = document.getElementById('assemble-icon')
const button6 = document.getElementById('assemble')
let mouse = new THREE.Vector2()
let sphere
let glowMat
let standardMaterial
let composer
let sun
let descriptionDiv
let gre
let ssaaRenderPass
let dracoLoader
let grePass
let sunMat
let loader1
let local
const posOld = []
const manager = new THREE.LoadingManager()

const helper = new THREE.AxesHelper()




//Buttons functionality//
button4.addEventListener("click", function () {
    let loaderDiv = document.getElementById('loader')
    loaderDiv.style.display = 'none'
    
    render()
    function render(){
      requestAnimationFrame( render)
      // renderer.clear();
      // camera.layers.set(0);
      camera.updateProjectionMatrix()
      composer.render();
      // renderer.clearDepth();
      // renderer.render(mainScene, camera)
      // model1.rotation.x += 0.004
    }
});
let state = 0
let state1 = 0
button5.addEventListener('click', function(){
  if (state == 0){
    controlIcon.style.backgroundColor = "#ed2424"
    mesh['Light'].material = sunMat
    gre = new GodRaysEffect(camera, mesh['Light'], {
      height: 480,
      kernelSize: 2,
      density: 1,
      decay: 0.9,
      weight: 0.5,
      exposure: 0.3,
      samples: 20,
      clampMax: 0.95
    })
    grePass = new EffectPass(camera, gre)
    composer.addPass(grePass)
    state = 1
    }else if (state == 1){
      controlIcon.style.backgroundColor = "transparent"
      mesh['Light'].material = standardMaterial
      composer.removePass(grePass)
  
      state = 0
    }
})

button6.addEventListener('click', function(){
  if (state1 == 0){
    //Button change//
    assembleIcon.style.backgroundColor = "#ed2424"

    //Camera zoom//
    // gsap.to( camera, {duration:0.7, delay:0.05, zoom:0.5})

    //Mesh change//
    gsap.to( model1.position, {duration:0.5, delay:0.1, x:10, y:0, z:10})

    gsap.to( mesh['Shell_right'].position, {duration:0.5, delay:0.4, z:-30})
    gsap.to( mesh['Shell_left'].position, {duration:0.5, delay:0.4, z:30})

    gsap.to( mesh['Screw2'].position, {duration:0.5, delay:0.1, z:-55} )
    gsap.to( mesh['Screw2'].rotation, {duration:0.5, delay:0.1, z:-15} )

    gsap.to( mesh['Screw1'].position, {duration:0.5, delay:0.1, z:-55} )
    gsap.to( mesh['Screw1'].rotation, {duration:0.5, delay:0.1, z:-15} )

    gsap.to( mesh['Post2'].position, {duration:0.5, delay:0.1, z:55} )
    gsap.to( mesh['Post2'].rotation, {duration:0.5, delay:0.1, z:-15} )

    gsap.to( mesh['Post1'].position, {duration:0.5, delay:0.1, z:55} )
    gsap.to( mesh['Post1'].rotation, {duration:0.5, delay:0.1, z:-15} )

    //Washers change//

    gsap.to( mesh['Washer8'].position, {duration:0.4, delay:0.5, z:-20})
    gsap.to( mesh['Washer7'].position, {duration:0.4, delay:0.52, z:-17})
    gsap.to( mesh['Washer6'].position, {duration:0.4, delay:0.54, z:-14})
    gsap.to( mesh['Washer5'].position, {duration:0.4, delay:0.56, z:-11})

    gsap.to( mesh['Washer2'].position, {duration:0.4, delay:0.5, z:25})

    gsap.to( mesh['Washer4'].position, {duration:0.4, delay:0.5, z:14})
    gsap.to( mesh['Washer20'].position, {duration:0.4, delay:0.52, z:10})
    gsap.to( mesh['Washer3'].position, {duration:0.4, delay:0.54, z:6})
    gsap.to( mesh['Washer14'].position, {duration:0.4, delay:0.56, z:2})
    gsap.to( mesh['Washer19'].position, {duration:0.4, delay:0.58, z:-2})

    gsap.to( mesh['Washer13'].position, {duration:0.4, delay:0.42, z:-24})

    gsap.to( mesh['Washer12'].position, {duration:0.4, delay:0.5, z:-14})
    gsap.to( mesh['Washer11'].position, {duration:0.4, delay:0.52, z:-10})
    gsap.to( mesh['Washer10'].position, {duration:0.4, delay:0.54, z:-6})
    gsap.to( mesh['Washer9'].position, {duration:0.4, delay:0.56, z:-2})

    gsap.to( mesh['Washer1'].position, {duration:0.4, delay:0.5, z:22})
    gsap.to( mesh['Washer18'].position, {duration:0.4, delay:0.52, z:18})
    gsap.to( mesh['Washer17'].position, {duration:0.4, delay:0.54, z:14})
    gsap.to( mesh['Washer16'].position, {duration:0.4, delay:0.56, z:10})
    gsap.to( mesh['Washer15'].position, {duration:0.4, delay:0.56, z:6})


    //Keys change//

    gsap.to( mesh['Key3'].position, {duration: 0.4, delay:0.57, z:-4})
    gsap.to( mesh['Multitool'].position, {duration: 0.4, delay:0.52, z:17})
    gsap.to( mesh['Key2'].position, {duration: 0.4, delay:0.44, z:-14})
    gsap.to( mesh['Key1'].position, {duration: 0.4, delay:0.44, z:3})

    gsap.to( mesh['Rubber_connector'].position, {duration:0.5, delay:0.2, x:-70} )
    

    state1 = 1
  }else if (state1 == 1){
    assembleIcon.style.backgroundColor = "transparent"


    //Camera zoom//
    // gsap.to( camera, {duration:0.7, delay:0.05, zoom: 1})

    //Mesh change//
    gsap.to( model1.position, {duration:0.5, delay:0.1, x:10,  y:5, z:0})

    gsap.to( mesh['Shell_right'].position, {duration:0.5, delay:0.1, z:-9.39096})
    gsap.to( mesh['Shell_left'].position, {duration:0.5, delay:0.1, z:10.1945})

    gsap.to( mesh['Screw2'].position, {duration:0.5, delay:0.1, z:-1.85774} )
    gsap.to( mesh['Screw2'].rotation, {duration:0.5, delay:0.1, z:0} )

    gsap.to( mesh['Screw1'].position, {duration:0.5, delay:0.3, z:-3.15775} )
    gsap.to( mesh['Screw1'].rotation, {duration:0.5, delay:0.3, z:0} )

    gsap.to( mesh['Post2'].position, {duration:0.5, delay:0.1, z:8.468} )
    gsap.to( mesh['Post2'].rotation, {duration:0.5, delay:0.1, z:25} )

    gsap.to( mesh['Post1'].position, {duration:0.5, delay:0.3, z:9.7679} )
    gsap.to( mesh['Post1'].rotation, {duration:0.5, delay:0.3, z:-25} )

    //Washers change//

    gsap.to( mesh['Washer8'].position, {duration:0.4, delay:0.16, z:-5.29642})
    gsap.to( mesh['Washer7'].position, {duration:0.4, delay:0.14, z:-4.39641})
    gsap.to( mesh['Washer6'].position, {duration:0.4, delay:0.12, z:-3.59645})
    gsap.to( mesh['Washer5'].position, {duration:0.4, delay:0.1, z:-2.79643})

    gsap.to( mesh['Washer2'].position, {duration:0.4, delay:0.1, z:6.40356})

    gsap.to( mesh['Washer4'].position, {duration:0.4, delay:0.14, z:3.60358})
    gsap.to( mesh['Washer20'].position, {duration:0.4, delay:0.16, z:2.80355})
    gsap.to( mesh['Washer3'].position, {duration:0.4, delay:0.18, z:2.00358})
    gsap.to( mesh['Washer14'].position, {duration:0.4, delay:0.2, z:1.20357})
    gsap.to( mesh['Washer19'].position, {duration:0.4, delay:0.22, z:0.403576})

    gsap.to( mesh['Washer13'].position, {duration:0.4, delay:0.1, z:-5.47221})

    gsap.to( mesh['Washer12'].position, {duration:0.4, delay:0.14, z:-2.37223})
    gsap.to( mesh['Washer11'].position, {duration:0.4, delay:0.16, z:-1.57222})
    gsap.to( mesh['Washer10'].position, {duration:0.4, delay:0.18, z:-0.772233})
    gsap.to( mesh['Washer9'].position, {duration:0.4, delay:0.2, z:0.027774})

    gsap.to( mesh['Washer1'].position, {duration:0.4, delay:0.14, z:6.52779})
    gsap.to( mesh['Washer18'].position, {duration:0.4, delay:0.16, z:5.72776})
    gsap.to( mesh['Washer17'].position, {duration:0.4, delay:0.18, z:4.92777})
    gsap.to( mesh['Washer16'].position, {duration:0.4, delay:0.2, z:4.12776})
    gsap.to( mesh['Washer15'].position, {duration:0.4, delay:0.22, z:3.32777})
    
    

    //Keys change//

    gsap.to( mesh['Key3'].position, {duration: 0.4, delay:0.18, z:2.00358})
    gsap.to( mesh['Multitool'].position, {duration: 0.4, delay:0.12, z:2.00358})
    gsap.to( mesh['Key2'].position, {duration: 0.4, delay:0.12, z:3.32777})
    gsap.to( mesh['Key1'].position, {duration: 0.4, delay:0.12, z:3})
    
    gsap.to( mesh['Rubber_connector'].position, {duration:0.3, delay:0.4, x:-40.9562} )

    state1 = 0
  }


})

document.addEventListener("keypress", function (e) {
  if (e.code == 'KeyA' && state1 == 0){
    //Button change//
    assembleIcon.style.backgroundColor = "#ed2424"

    //Camera zoom//
    // gsap.to( camera, {duration:0.7, delay:0.05, zoom:0.5})

    //Mesh change//
    gsap.to( model1.position, {duration:0.5, delay:0.1, x:10, y:0, z:10})

    gsap.to( mesh['Shell_right'].position, {duration:0.5, delay:0.4, z:-30})
    gsap.to( mesh['Shell_left'].position, {duration:0.5, delay:0.4, z:30})

    gsap.to( mesh['Screw2'].position, {duration:0.5, delay:0.1, z:-55} )
    gsap.to( mesh['Screw2'].rotation, {duration:0.5, delay:0.1, z:-15} )

    gsap.to( mesh['Screw1'].position, {duration:0.5, delay:0.1, z:-55} )
    gsap.to( mesh['Screw1'].rotation, {duration:0.5, delay:0.1, z:-15} )

    gsap.to( mesh['Post2'].position, {duration:0.5, delay:0.1, z:55} )
    gsap.to( mesh['Post2'].rotation, {duration:0.5, delay:0.1, z:-15} )

    gsap.to( mesh['Post1'].position, {duration:0.5, delay:0.1, z:55} )
    gsap.to( mesh['Post1'].rotation, {duration:0.5, delay:0.1, z:-15} )

    //Washers change//

    gsap.to( mesh['Washer8'].position, {duration:0.4, delay:0.5, z:-20})
    gsap.to( mesh['Washer7'].position, {duration:0.4, delay:0.52, z:-17})
    gsap.to( mesh['Washer6'].position, {duration:0.4, delay:0.54, z:-14})
    gsap.to( mesh['Washer5'].position, {duration:0.4, delay:0.56, z:-11})

    gsap.to( mesh['Washer2'].position, {duration:0.4, delay:0.5, z:25})

    gsap.to( mesh['Washer4'].position, {duration:0.4, delay:0.5, z:14})
    gsap.to( mesh['Washer20'].position, {duration:0.4, delay:0.52, z:10})
    gsap.to( mesh['Washer3'].position, {duration:0.4, delay:0.54, z:6})
    gsap.to( mesh['Washer14'].position, {duration:0.4, delay:0.56, z:2})
    gsap.to( mesh['Washer19'].position, {duration:0.4, delay:0.58, z:-2})

    gsap.to( mesh['Washer13'].position, {duration:0.4, delay:0.42, z:-24})

    gsap.to( mesh['Washer12'].position, {duration:0.4, delay:0.5, z:-14})
    gsap.to( mesh['Washer11'].position, {duration:0.4, delay:0.52, z:-10})
    gsap.to( mesh['Washer10'].position, {duration:0.4, delay:0.54, z:-6})
    gsap.to( mesh['Washer9'].position, {duration:0.4, delay:0.56, z:-2})

    gsap.to( mesh['Washer1'].position, {duration:0.4, delay:0.5, z:22})
    gsap.to( mesh['Washer18'].position, {duration:0.4, delay:0.52, z:18})
    gsap.to( mesh['Washer17'].position, {duration:0.4, delay:0.54, z:14})
    gsap.to( mesh['Washer16'].position, {duration:0.4, delay:0.56, z:10})
    gsap.to( mesh['Washer15'].position, {duration:0.4, delay:0.56, z:6})


    //Keys change//

    gsap.to( mesh['Key3'].position, {duration: 0.4, delay:0.57, z:-4})
    gsap.to( mesh['Multitool'].position, {duration: 0.4, delay:0.52, z:17})
    gsap.to( mesh['Key2'].position, {duration: 0.4, delay:0.44, z:-14})
    gsap.to( mesh['Key1'].position, {duration: 0.4, delay:0.44, z:3})

    gsap.to( mesh['Rubber_connector'].position, {duration:0.5, delay:0.2, x:-70} )
    

    state1 = 1
  }else if (e.code == 'KeyA' && state1 == 1){
    assembleIcon.style.backgroundColor = "transparent"


    //Camera zoom//
    // gsap.to( camera, {duration:0.7, delay:0.05, zoom: 1})

    //Mesh change//
    gsap.to( model1.position, {duration:0.5, delay:0.1, x:10,  y:5, z:0})

    gsap.to( mesh['Shell_right'].position, {duration:0.5, delay:0.1, z:-9.39096})
    gsap.to( mesh['Shell_left'].position, {duration:0.5, delay:0.1, z:10.1945})

    gsap.to( mesh['Screw2'].position, {duration:0.5, delay:0.1, z:-1.85774} )
    gsap.to( mesh['Screw2'].rotation, {duration:0.5, delay:0.1, z:0} )

    gsap.to( mesh['Screw1'].position, {duration:0.5, delay:0.3, z:-3.15775} )
    gsap.to( mesh['Screw1'].rotation, {duration:0.5, delay:0.3, z:0} )

    gsap.to( mesh['Post2'].position, {duration:0.5, delay:0.1, z:8.468} )
    gsap.to( mesh['Post2'].rotation, {duration:0.5, delay:0.1, z:25} )

    gsap.to( mesh['Post1'].position, {duration:0.5, delay:0.3, z:9.7679} )
    gsap.to( mesh['Post1'].rotation, {duration:0.5, delay:0.3, z:-25} )

    //Washers change//

    gsap.to( mesh['Washer8'].position, {duration:0.4, delay:0.16, z:-5.29642})
    gsap.to( mesh['Washer7'].position, {duration:0.4, delay:0.14, z:-4.39641})
    gsap.to( mesh['Washer6'].position, {duration:0.4, delay:0.12, z:-3.59645})
    gsap.to( mesh['Washer5'].position, {duration:0.4, delay:0.1, z:-2.79643})

    gsap.to( mesh['Washer2'].position, {duration:0.4, delay:0.1, z:6.40356})

    gsap.to( mesh['Washer4'].position, {duration:0.4, delay:0.14, z:3.60358})
    gsap.to( mesh['Washer20'].position, {duration:0.4, delay:0.16, z:2.80355})
    gsap.to( mesh['Washer3'].position, {duration:0.4, delay:0.18, z:2.00358})
    gsap.to( mesh['Washer14'].position, {duration:0.4, delay:0.2, z:1.20357})
    gsap.to( mesh['Washer19'].position, {duration:0.4, delay:0.22, z:0.403576})

    gsap.to( mesh['Washer13'].position, {duration:0.4, delay:0.1, z:-5.47221})

    gsap.to( mesh['Washer12'].position, {duration:0.4, delay:0.14, z:-2.37223})
    gsap.to( mesh['Washer11'].position, {duration:0.4, delay:0.16, z:-1.57222})
    gsap.to( mesh['Washer10'].position, {duration:0.4, delay:0.18, z:-0.772233})
    gsap.to( mesh['Washer9'].position, {duration:0.4, delay:0.2, z:0.027774})

    gsap.to( mesh['Washer1'].position, {duration:0.4, delay:0.14, z:6.52779})
    gsap.to( mesh['Washer18'].position, {duration:0.4, delay:0.16, z:5.72776})
    gsap.to( mesh['Washer17'].position, {duration:0.4, delay:0.18, z:4.92777})
    gsap.to( mesh['Washer16'].position, {duration:0.4, delay:0.2, z:4.12776})
    gsap.to( mesh['Washer15'].position, {duration:0.4, delay:0.22, z:3.32777})
    
    

    //Keys change//

    gsap.to( mesh['Key3'].position, {duration: 0.4, delay:0.18, z:2.00358})
    gsap.to( mesh['Multitool'].position, {duration: 0.4, delay:0.12, z:2.00358})
    gsap.to( mesh['Key2'].position, {duration: 0.4, delay:0.12, z:3.32777})
    gsap.to( mesh['Key1'].position, {duration: 0.4, delay:0.12, z:3})
    
    gsap.to( mesh['Rubber_connector'].position, {duration:0.3, delay:0.4, x:-40.9562} )

    state1 = 0
  }
});







document.addEventListener("keypress", function (e) {
  if (e.code == "KeyS" && state == 0){
  controlIcon.style.backgroundColor = "#ed2424"
  mesh['Light'].material = sunMat
  gre = new GodRaysEffect(camera, mesh['Light'], {
    height: 480,
    kernelSize: 2,
    density: 1,
    decay: 0.9,
    weight: 0.5,
    exposure: 0.3,
    samples: 20,
    clampMax: 0.95
  })
  grePass = new EffectPass(camera, gre)
  composer.addPass(grePass)
  state = 1
  }else if (e.code == "KeyS" && state == 1){
    controlIcon.style.backgroundColor = "transparent"
    mesh['Light'].material = standardMaterial
    composer.removePass(grePass)

    state = 0
  }
});

button3.addEventListener('click', function(){
  mesh['Light'].material = standardMaterial
  composer.removePass(grePass)
})

//Assembly animation//




//Position tracking on cursor//
function addElement(){

  const newDiv = document.getElementById('cursorDiv')
  newDiv.setAttribute('class','cursorDivClass')
  const divX = document.createElement('divX')
  const divY = document.createElement('divY')
  const divXValue = document.createElement('divXValue')
  const divYValue = document.createElement('divYValue')
  // newDiv.appendChild(divX)
  // newDiv.appendChild(divXValue)
  // newDiv.appendChild(divY)
  
  // newDiv.appendChild(divYValue)
  divX.setAttribute('class','font')
  divY.setAttribute('class','font1')
  divXValue.setAttribute('class', 'font2')
  divYValue.setAttribute('class', 'font3')
  
  const mousePosDivX = document.createTextNode('x:')
  const mousePosDivY = document.createTextNode('y:')
  const mousePosDivXValue = document.createTextNode('')
  const mousePosDivYValue = document.createTextNode('')
  
  
  document.addEventListener('mousemove', function(e){
    var mouseX = e.clientX
    var mouseY = e.clientY
    var screenHeight = document.body.clientHeight
    var screenWidth = document.body.clientWidth
    var cursorHeight = newDiv.clientHeight
    var cursorWidth = newDiv.clientWidth
    //Used for mouse pointer
    newDiv.style.left = mouseX-7.5 + 'px'
    newDiv.style.top = mouseY-7.5 + 'px'

    // Used for point cooridantes//
    // if (mouseX + cursorWidth < screenWidth-10) {
    //   newDiv.style.left = mouseX+10 +'px'

    // } else{
    //   newDiv.style.left = mouseX -cursorWidth - 5 + 'px'

    // }
    
    // if(mouseY + cursorHeight < screenHeight-15){
    //   newDiv.style.top = mouseY+15 +'px'

    // } else{
    //   newDiv.style.top = mouseY-cursorHeight - 5 +'px'

    // }
    // Used for point cooridantes//

    divX.appendChild(mousePosDivX)
    divXValue.appendChild(mousePosDivXValue)
    divY.appendChild(mousePosDivY)
    divYValue.appendChild(mousePosDivYValue)
    mousePosDivXValue.nodeValue = mouseX + ' '
    mousePosDivYValue.nodeValue = mouseY
    

  })
  document.body.appendChild(newDiv)


}
addElement()

//Text field//
function addTextDiv(){
  txtDiv = document.createElement('txtDiv')
  txtDiv.setAttribute('class','txtDiv')
  document.body.appendChild(txtDiv)
  const text = document.createTextNode("KeySmart MAX™")
  txtDiv.appendChild(text)
  descriptionDiv = document.createElement('desDiv')
  descriptionDiv.setAttribute('class', 'desDiv')
  txtDiv.appendChild(descriptionDiv)
  const description = document.createTextNode(
    'KeySmart Max is a key organizer and keychain accessory that\'s designed to make your life easier.\n \nIt\'s a slim, lightweight key organizer that fits in any pocket or purse. If you\'ve got one of those tiny pockets on your pants, you\'ll be happy to know that KeySmart Max fits right in there. It comes with an additional key ring so you can carry even more keys - and it also has a built-in carabiner clip that allows you to attach it to your belt loop or other objects.')
  descriptionDiv.appendChild(description)
  
}
addTextDiv()

function addButton(){
  const but1Div = document.createElement('BUTTON')
  but1Div.setAttribute('class', 'but1Div')
  const but1Txt = document.createTextNode('Learn More')
  but1Div.appendChild(but1Txt)
  descriptionDiv.appendChild(but1Div)
  but1Div.onclick = function(){
    window.open('https://www.getkeysmart.com/products/keysmart-max', "_self")
  }
  
}
addButton()

function createToolTip (){
  const toolTipDiv = document.createElement('toolTip')
  document.getElementsByTagName('body')[0].appendChild(toolTipDiv)
}

function addInputControls(){

  //Main Div//
  const inputDiv = document.createElement('inputDiv')
  inputDiv.setAttribute('class','inputDiv')

  //Main Div//

  //Input fields//
  inputXpos = document.createElement('INPUT')
  inputYpos = document.createElement('INPUT')
  inputZpos = document.createElement('INPUT')

  inputXpos.setAttribute('class','inputX')
  inputYpos.setAttribute('class','inputY')
  inputZpos.setAttribute('class','inputZ')

  //Input fields//

  //adding elements to the page//
  document.body.appendChild(inputDiv)
  inputDiv.appendChild(inputXpos)
  inputDiv.appendChild(inputYpos)
  inputDiv.appendChild(inputZpos)

  //adding elements to the page//

}

window.onload = addInputControls()
window.onload = createToolTip()


//Input for custom position of the point//
document.addEventListener('keypress', getInputValue, true)

function getInputValue(e){
  let focus = document.activeElement
  if(e.key === 'Enter' && focus == inputXpos){
    mesh['Shell_right'].position.x = inputXpos.value
    
  }else if(e.key === 'Enter' && focus == inputYpos){

    mesh['Shell_right'].position.z = inputYpos.value
  }else if(e.key === 'Enter' && focus == inputZpos){

    mesh['Shell_right'].position.y = inputZpos.value
  }
}



//ToolTip initialization on mouse hover over button//
button1.addEventListener('mouseover', (function () {
  const toolTip = document.getElementsByTagName('tooltip')[0]
  toolTip.innerHTML = '<object type="image/svg+xml" data="toolTip_Line.svg"></object>'
  toolTip.setAttribute("class", "toolTip")

  lottie.loadAnimation({
    container: toolTip,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: 'data.json',
    rendererSettings:{
      className: 'lottie'
    }
  })

  toolTip.style.left = e.clientX - 10 + "px"
  toolTip.style.top = e.clientY +2+ "px"
}))

const toolTip = document.getElementsByTagName('tooltip')[0]
toolTip.addEventListener('mouseover', function(){
  
  toolTip.setAttribute("class","toolTip")
})
toolTip.addEventListener('mouseout',function(){
  
  toolTip.setAttribute("class","toolTipHidden")
})

button1.addEventListener('mouseleave', function(){
  
  const toolTipDist = document.getElementsByTagName('tooltip')[0]
  toolTipDist.setAttribute("class","toolTipHidden")
})


//Main function//
init()
// render()

function init(){

//Main scene setup//
  mainScene = new THREE.Scene()
  camera = new THREE.PerspectiveCamera(55, window.innerWidth/ window.innerHeight, 1, 10000)
  camera.position.set(15,17,-20)
  camera.layers.enable(1)
  // mainScene.add(helper)
  
  envLoader = new RGBELoader()

  //SUN//
  let sunGeo = new SphereBufferGeometry(0.65, 15, 15)
  sunMat = new MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    fog: false
  })
  sun = new Mesh(sunGeo, sunMat)
  sun.frustumCulled = false
  sun.matrixAutoUpdate = false
  // sun.layers.set(1)
  // mainScene.add(sun)

// HDRI Loader//

  // envLoader.load("circus_arena_1k.hdr", function ( texture ){
  //   texture.mapping = THREE.EquirectangularReflectionMapping
  //   mainScene.enviroment = texture 
  //   composer.render()
  // })

//Lights setup//
  light = new THREE.AmbientLight({color: 0xff00ff, intensity:0.1})
  directionalLight = new THREE.DirectionalLight(0xc4d5f7, 1, 100000)
  light2 = new THREE.DirectionalLight(0xffffff, 1, 10000)
  light2.position.set(0,0,100)
  light2.lookAt(0,0,0)
  let light3 = new THREE.DirectionalLight(0xffffff, 1, 10000)
  light3.position.set(100,0,0)
  light3.lookAt(0,0,0)
  let light4 = new THREE.DirectionalLight(0x2962d3, 1, 10000)
  light4.position.set(5,-20,0)
  light4.lookAt(0,0,0)
  let light5 = new THREE.DirectionalLight(0xc50ff2, 1, 10000)
  light5.position.set(-5,20,0)
  light5.lookAt(0,0,0)



  mainScene.background = new THREE.Color("black")
  material = new THREE.MeshStandardMaterial(0x00ff00)
  glowMat = new THREE.MeshPhysicalMaterial({
    transmission: 0.8,
    roughness: 0.08,
    iro: 1.5,
    specularIntensity: 1
  })
  standardMaterial = new THREE.MeshStandardMaterial({
    color:0x000000,
    opacity: 0.5
  })
 



  /////RENDERER/////

  renderer = new THREE.WebGLRenderer({ 
    antialias: true, 
    depth:true, 
    powerPreference:"high-performance",
    logarithmicDepthBuffer: true,
    clearColor: 0x0000ff
  })

  
  
  
  
  
  renderer.setPixelRatio( window.devicePixelRatio )
  renderer.setSize( window.innerWidth, window.innerHeight )

  renderer.outputEncoding = THREE.sRGBEncoding
  renderer.physicallyCorrectLights = true
  renderer.autoClear = true
  renderer.alpha = false
  gre = new GodRaysEffect(camera, sun, {
    height: 480,
    kernelSize: 2,
    density: 1,
    decay: 0.9,
    weight: 0.5,
    exposure: 0.3,
    samples: 20,
    clampMax: 0.95,
    clearColor: 0x00ff00
  })
	var parameters = { minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter, format: THREE.RGBAFormat, stencilBuffer: true };

	var renderTarget = new THREE.WebGLRenderTarget( window.width, window.height, parameters ); 
  
  
  composer = new EffectComposer(renderer, renderTarget)
  composer.addPass(new RenderPass(mainScene, camera))
  
  composer.antialias = true
  composer.alpha = true
  composer.outputEncoding = THREE.sRGBEncoding
  composer.ToneMapping = THREE.ACESFilmicToneMapping
  
  
  // composer.addPass(new SSAARenderPass( mainScene, camera ))
  
  composer.setSize(window.innerWidth, window.innerHeight)
  // composer.outputEncoding = THREE.LinearEncoding

  //TEST CUBE//
  let cubeGeo = new THREE.BoxGeometry(5,5,5)
  let cubeMat = new THREE.MeshPhysicalMaterial(0xff00ff)
  let cube = new THREE.Mesh(cubeGeo, cubeMat)
  cube.scale.set(5,5,5)
  // mainScene.add(cube)

  //Plane//

  

  let canvas = document.body.appendChild( renderer.domElement )

  raycaster = new Raycaster()

  oControls = new OrbitControls (camera, renderer.domElement)
  oControls.enabled = false
  oControls.update()
  // oControls.addEventListener('change', render)
  mainScene.add(camera, light, directionalLight, light2, light3, light4, light5)
  model1 = new THREE.Object3D()
  
  tControls = new TransformControls(camera, renderer.domElement)
  mainScene.add(tControls)
  // tControls.addEventListener('change', render)
  tControls.addEventListener('dragging-changed',
  function(event){
    oControls.enabled = !event.value
  })



 
  
 
//Model loading//
  dracoLoader = new DRACOLoader()
  dracoLoader.setDecoderPath( "https://www.gstatic.com/draco/v1/decoders/" )
  loader1 = new GLTFLoader(manager)
  loader1.setDRACOLoader( dracoLoader )

  console.log("Starting the load function...")

  // loader1.load("/KS_Max_Light.gltf", function(gltf){
    
  //   console.log("Loading now...")
  //   mainScene.add(model1)
  //   model1.add(gltf.scene)
  //   console.log("Model loaded")  
  //   model1.scale.set(0.2,0.2,0.2)
  //   model1.position.set(10,5,0)
    
  //   model1.traverse(function(child){
  //     if(child.isMesh){
  //       mesh[child.name] = child
  //       child.layers.set(0)
  //     }
  //   })
    
    
  //   console.log("Assuming loading completed.")
    
  // })

  loader1.load("/KS_Max.gltf", function(gltf){
    console.log("Loading now...")
    mainScene.add(model1)
    model1.add(gltf.scene)
    console.log("Model loaded")  
    model1.scale.set(0.2,0.2,0.2)
    model1.position.set(10,5,0)
    
    model1.traverse(function(child){
      if(child.isMesh){
        mesh[child.name] = child
        child.layers.set(0)
      }
    })
    mesh['Glass_Light_Small'].material = standardMaterial
    console.log("Assuming loading completed.")
  })
  manager.onProgress = function (url, itemsLoaded, itemsTotal){
    console.log(itemsLoaded/itemsTotal*100+'%')
  }

  manager.onLoad = function (){
    mesh['Light'].material = standardMaterial
    mesh['Light'].layers.set(0)
    model1.rotation.set(0,0.5,0)
    
  }


  

//Model rotation//
  document.addEventListener('mousemove' , onDocumentMouseMove, false)

  function onDocumentMouseMove(event){

    mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
    mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
    model1.rotation.x = mouse.y/2
    model1.rotation.z = mouse.x/2
    mesh['Key1'].rotation.z = mouse.y*0.4
    mesh['Key2'].rotation.z = mouse.y*1.3
    mesh['Key3'].rotation.z = mouse.y*0.6
    mesh['Multitool'].rotation.z = mouse.y
  }
  // document.addEventListener( 'pointerdown', onDocumentMouseDown, false );

  // function onDocumentMouseDown(event) {
  //   mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
  //   mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

  //   // var intersects = raycaster.intersectObject( mesh['Button2'] )
  //   // raycaster.setFromCamera( mouse, camera )
  //   // if(intersects.length > 0) { 
      
  //   //   gsap.fromTo(camera.position,{x:15, y:17, z:-20}, {duration: 0.5, delay: 0.2, x:25, y:5, z:-10})
  //   //   gsap.fromTo( mesh['Button2'].position,{z:0}, {duration:0.5, delay:0.1, z:0.1} )
  //   //   mesh['Light'].material = glowMat

  //   // } else {
      
  //   //   gsap.fromTo(camera.position, {x:25, y:5, z:-10}, {x:15, y:17, z:-20, duration:0.5, delay:0.2})
  //   //   gsap.fromTo(mesh['Button2'].position, {z:0.1},{duration:0.5, delay:0.1, z:0})
  //   //   mesh['Light'].material = standardMaterial
  //   // }
  // }
  
}

window.addEventListener("resize",

  function () {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  }
)



